<template>
  <div class="tutorial-root">
    <main class="tutorial-content">
      <div class="container">
        <div class="tutorial-layout">
          <!-- 左侧导航 -->
          <aside class="tutorial-sidebar">
            <nav class="sidebar-nav">
              <div class="nav-group">
                <!-- <router-link to="/" class="nav-group-item">
                  <svg class="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                  </svg>
                  返回首页
                </router-link> -->
                <div class="nav-section-title">教程中心</div>
                <a v-for="(section, index) in sections" 
                   :key="index"
                   :href="'#section-' + index"
                   class="nav-section-link"
                   :class="{ 'active': currentSection === index }"
                   @click.prevent="scrollToSection(index)">
                  {{ section.title }}
                </a>

              </div>
            </nav>
          </aside>

          <!-- 右侧内容 -->
          <div class="tutorial-main">
            <article class="content-wrapper">
              <!-- 1. 快速开始 -->
              <section id="section-0" class="doc-section">
                <h1>1. 快速开始</h1>
                
                <div class="subsection">
                  <h2>1.1 基础设置</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 下载与安装</strong>
                      <p>访问官网 <a href="https://www.linkoffer.cn" target="_blank">www.linkoffer.cn</a>，获取对应系统的客户端。</p>
                      <p><strong>Windows：</strong>运行安装包并双击桌面图标启动。</p>
                      <p><strong>Mac：</strong>将应用拖入应用程序。若无法打开，请尝试"右键打开"或在"系统设置-隐私与安全性"中点击"仍要打开"。</p>
                    </li>
                    <li>
                      <strong>(2) 会员充值</strong>
                      <p>在会员充值页面，根据预估的面试时长计算所需的"面试币"数量。支持选择固定套餐或自定义金额充值，确保面试过程顺利进行。</p>
                    </li>
                    <li>
                      <strong>(3) 面试准备</strong>
                      <p><strong>创建面试：</strong>在移动端（手机/平板）登录官网，点击"立即开始"，创建面试并填写面试必要信息，进入 IP 输入界面。</p>
                      <p><strong>设备连接：</strong>启动电脑客户端并完成音频测试，获取客户端 IP，将其粘贴至移动端完成两端设备连接，点击"启动远端音频链接"。</p>
                    </li>
                    <li>
                      <strong>(4) 开始面试</strong>
                      <p>点击"开始面试"进入实时交互界面。</p>
                      <p><strong>AI 辅助回答：</strong>普通问题用"快答"，编程/逻辑题推荐"深度回答"。支持截图回答、联网搜索及手动修正识别内容。</p>
                      <p><strong>记录复盘：</strong>面试结束后点击"结束面试"，可随时在后台查看所有沟通记录。</p>
                    </li>
                  </ol>
                </div>

                <div class="subsection">
                  <h2>1.2 产品演示</h2>
                   <ol class="number-list">
                    <p><a href="https://www.bilibili.com/video/BV1Mc1VBFEPM/?vd_source=a250cf4fdf0a7ba7afb23233c5a18ab3" target="_blank">https://www.bilibili.com/video/BV1Mc1VBFEPM/?vd_source=a250cf4fdf0a7ba7afb23233c5a18ab3</a></p>
                </ol>
                </div>
              </section>

              <!-- 2. 产品定价与充值 -->
              <section id="section-1" class="doc-section">
                <h1>2. 产品定价与充值</h1>
                <div class="subsection">
                  <h2>2.1 定价策略</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 定价依据</strong>
                      <p>我们的定价是基于当前主流大模型（如gpt,gemini,claude等）的调用成本设定，真实透明，无隐性收费。</p>
                    </li>
                    <li>
                      <strong>(2) 高性价比</strong>
                      <p>为了帮助更多求职者高效备战面试，我们坚持全网低价、合理定价，致力于提供人人都用得起的AI模拟面试服务。</p>
                    </li>
                  </ol>
                </div>
                <div class="subsection">
                  <h2>2.2 产品充值</h2>
                    <ol class="number-list">
                    <li>
                      <strong>(1) 如何充值</strong>
                      <p>您可以在"会员充值"页面按需充值，充值的金额将自动转化为面试币（1元=1币）。</p>
                    </li>
                    <li>
                      <strong>(2) 支付方式</strong>
                      <p>目前支持支付宝、微信扫码支付，安全可靠、支付后实时到账。</p>
                    </li>
                  </ol>
                </div>

                

                <div class="subsection">
                  <h2>2.3 费用说明</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 计费规则</strong>
                      <p>我们将按照您的面试时长、快答/深度回答/截图回答次数进行综合计费（面试时长不足一分钟，按一分钟进行计算）。</p>
                    </li>
                    <li>
                      <strong>(2) 余额提醒</strong>
                      <p>若您的余额不足，面试可能中止，请在面试前确保您的余额充足。</p>
                    </li>
                  </ol>
                </div>
                <div class="subsection">
                  <h2>2.4 余额管理</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 余额查询</strong>
                      <p>您可以在"用户中心"查看您的当前余额以及使用记录。</p>
                    </li>
                    <li>
                      <strong>(2) 退款规则</strong>
                      <p>您可在"用户中心"申请退款，我们将在1~10个工作日内处理您的申请（赠送的面试币不支持退款）。</p>
                    </li>
                  </ol>
                </div>
                
              </section>

            

              <!-- 3. 常见问题 -->
              <section id="section-2" class="doc-section">
                <h1>3. 常见问题</h1>
                
                <div class="subsection">
                  <h2>3.1 产品功能</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 支持哪些行业和岗位？</strong>
                      <p>大模型知识库覆盖多样化职业，对编程/产品经理/运营/市场/律师/金融等多个岗位做针对性模型优化。</p>
                    </li>
                    <li>
                      <strong>(2) 支持哪些面试平台？
                      </strong>
                      <p>我们支持绝大多数的视频会议软件，常见的客户端如腾讯会议/飞书/钉钉等均可使用，同时支持网页端面试。</p>
                    </li>
                    <li>
                      <strong>(3) 如何使用我们的产品？</strong>
                      <p>您需要下载Linkoffer客户端，推荐您使用电脑端的视频软件进行模拟面试，用移动端（平板/手机）浏览器登录Linkoffer网页（www.linkoffer.cn），根据页面提示使用产品，详情见"教程中心"。</p>
                    </li>
                    <li>
                      <strong>(4) AI回答不准确怎么办？</strong>
                      <p>大模型目前的准确率无法做到100%，回答只能作为参考，我们将持续优化算法，不断提高准确率上限。</p>
                    </li>
                  </ol>
                </div>

                

                <div class="subsection">
                  <h2>3.2 隐私与安全</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 使用AI时，我说的话会被保存吗？</strong>
                      <p>我们尊重用户隐私，所有语音内容仅用于实时处理，您的面试记录仅会在您的本地保存，不会存储至云数据库中。</p>
                    </li>
                    <li>
                      <strong>(2) 如何打开系统权限？</strong>
                      <p>客户端需要您授权系统权限，才可以正常获取到您的面试音频，请在客户端引导中按照步骤打开权限。具体可看《产品演示视频》。</p>
                    </li>
                    <li>
                      <strong>(3) 如何注销账号？</strong>
                      <p>您可在"用户中心"注销账号，注销过程不可逆，一旦操作将删除您账号的所有数据。</p>
                    </li>
                  </ol>
                </div>

                <div class="subsection">
                  <h2>3.3 网络问题</h2>
                  <ol class="number-list">
                    <li>
                      
                      <p>网络卡顿可能会影响AI回答效果，建议您在面试前进行网络测试，确保面试中不出现突发情况。</p>
                    </li>
                  </ol>
                </div>
              </section>

            

              <!-- 4. 联系我们 -->
              <section id="section-3" class="doc-section">
                <h1>4. 联系我们</h1>
                <div class="subsection">
                  <h2>4.1 联系方式</h2>
                  <ol class="number-list">
                    <li>
                      <strong>(1) 邮箱</strong>
                      <p>linkoffer@yeah.net</p>
                    </li>
                    <li>
                      <strong>(2) 服务时间</strong>
                      <p>工作日 10:00 - 18:00</p>
                    </li>
                  </ol>
                </div>
              </section>

              <!-- 5. 用户协议 -->
              <section id="section-4" class="doc-section">
                <h1>5. 用户协议</h1>
                <div class="subsection">
                  <h2>一. 服务定位</h2>
                  <p>1.1 本平台提供的用于学习、训练、模拟为目的面试能力提升服务，帮助用户提升面试能力和技术素养；</p>
                  <p>1.2 本平台服务仅以提升面试能力为目的，不得用于其他目的。</p>
                </div>

                <div class="subsection">
                  <h2>二. 账户与安全</h2>
                  <p>2.1 用户应使用真实有效的手机号、邮箱进行注册；</p>
                  <p>2.2 用户有义务妥善保管账户，如因用户自身原因导致的账户泄露、信息丢失，平台不承担责任；</p>
                  <p>2.3 账户注销（1）用户可以在个人中心注销其平台账户；（2）若账户存在未完成的交易或未结清的款项、涉嫌违规等情况，平台有权在问题解决后再行处理注销申请；（3）注销后，用户将无法继续使用本平台提供的任何服务，相关账户数据将被永久删除（但法律法规另有规定的除外），且信息一经删除不可恢复，如因此造成损失的，平台不承担任何责任；（4）平台将在用户发起注销请求后，在15个工作日内完成账户注销及个人信息的清除工作，包括但不限于注册信息、使用记录、充值记录、积分信息等；（5）注销后，用户与平台之间的所有服务协议即时终止，平台不再承担任何服务或技术支持义务。</p>
                </div>

                <div class="subsection">
                  <h2>三. 数据合规</h2>
                  <p>平台将严格按照《中华人民共和国个人信息保护法》等相关法律法规的规定，收集、使用、存储和保护用户的个人信息，除本平台服务必要需求外，非必要信息不作收集、存储，敏感数据将作用户本地存储。</p>
                </div>

                <div class="subsection">
                  <h2>四. 用户行为规范</h2>
                  <p>用户在使用本平台服务时，承诺以下内容：</p>
                  <p>4.1 用户所提交的资料真实、完整，不存在虚假信息；</p>
                  <p>4.2 用户不得冒用他人身份注册账户，不得重复注册多个账号恶意获取平台资源，不得通过虚假手机号及邮箱，或其他虚假信息恶意注册账户。如有违法行为，平台有依法追溯权利；</p>
                  <p>4.3 用户在使用平台服务时，必须遵守中华人民共和国的法律法规，不得利用平台从事任何违法、违规行为：包括不限于利用平台服务参与任何形式的虚假招聘、非法代考、技术欺诈、身份伪造等违法行为；</p>
                  <p>4.4 用户承诺所有模拟面试行为仅为个人学习目的，不得用于工作、学术等面试中的作弊行为。严禁将本平台服务用于国家规定的相关考试，包括不限于法考、公考、高考、研究生考试等。本平台有权对上述违法行为享有依法追溯、举报权利；</p>
                  <p>4.5 用户不得通过任何技术手段试图绕过计费系统，不得进行任何可能破坏、干扰、修改或影响本平台正常运作的行为。如有违法行为，平台有依法追溯权利。</p>
                </div>

                <div class="subsection">
                  <h2>五. 平台权利</h2>
                  <p>5.1 平台有权在发现用户存在违规或违法行为时，立即暂停或终止服务，并有权依法向有关部门报备；</p>
                  <p>5.2 必要情形下，平台保留对用户使用记录进行存档、审查和分析的权利；</p>
                </div>

                <div class="subsection">
                  <h2>六. 知识产权</h2>
                  <p>6.1 平台的所有内容，包括但不限于界面设计、生成内容、技术服务、相关数据等，均受相关知识产权法律保护；</p>
                  <p>6.2 未经许可，用户不得复制、传播、商业使用平台内容；</p>
                  <p>6.3 用户需承诺，在使用本服务时提交的信息不侵犯他人合法权益，也不涉及国家秘密、商业机密或其他敏感数据。如因用户的行为引发纠纷或损失，用户将自行承担全部责任，并赔偿平台的损失。</p>
                </div>

                <div class="subsection">
                  <h2>七. 免责声明</h2>
                  <p>7.1 用户因违反本协议而引发的任何法律责任，平台不承担任何连带责任；</p>
                  <p>7.2 用户在使用平台服务过程中，因自身行为导致的任何损失或法律责任，平台不承担责任；</p>
                  <p>7.3 平台提供的模拟评估及回答仅供参考，不构成正式意见。平台不对用户参与第三方面试、招聘等行为承担任何结果责任；</p>
                  <p>7.4 平台将尽力确保服务的连续性和安全性，但因不可抗力或其他非平台原因导致的服务中断或数据丢失除外。</p>
                </div>

                <div class="subsection">
                  <h2>八. 协议变更</h2>
                  <p>平台有权根据需要修改本协议，修改后的协议将通过平台公告或其他适当方式通知用户。用户继续使用平台服务，即视为接受修改后的协议。</p>
                </div>

                <div class="subsection">
                  <h2>九. 法律适用</h2>
                  <p>本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。因本协议引起的或与本协议有关的争议，双方应友好协商解决；协商不成的，任何一方均可向平台所在地有管辖权的人民法院提起诉讼。</p>
                  <p class="agreement-footer">感谢您遵守规范，共同打造真实、可信、专业的技术成长社区。如您有任何疑问、建议或投诉，请通过邮箱与我们联系：邮箱：linkoffer@yeah.net</p>
                </div>
              </section>
            </article>
          </div>
        </div>
      </div>
    </main>

    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <span>© 2025 Linkoffer. 保留所有权利.</span>
          <span>联系方式：linkoffer@yeah.net</span>
        </div>
      </div>
    </footer>

    <!-- <LoginModal ref="loginModal" /> -->
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
// import LoginModal from '@/components/LoginModal.vue'
// import { tutorialContent } from '@/config/tutorial.js'

// const loginModal = ref(null)
const currentSection = ref(0)
const showTooltip = ref(0)

const sections = [
  { title: '1. 快速开始' },
  { title: '2. 产品定价与充值' },
  { title: '3. 常见问题' },
  { title: '4. 联系我们' },
  { title: '5. 用户协议' }
]

// const showLoginModal = () => {
//   loginModal.value.showModal()
// }

const scrollToSection = (index) => {
  const element = document.getElementById('section-' + index)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

const updateCurrentSection = () => {
  const sections = document.querySelectorAll('.doc-section')
  let current = 0
  
  sections.forEach((section, index) => {
    const rect = section.getBoundingClientRect()
    if (rect.top <= 100) {
      current = index
    }
  })
  
  currentSection.value = current
}

onMounted(() => {
  window.addEventListener('scroll', updateCurrentSection)
})

onUnmounted(() => {
  window.removeEventListener('scroll', updateCurrentSection)
})
</script>

<style scoped>
.tutorial-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
}

.tutorial-content {
  flex: 1;
  padding: 24px 0;
}

.tutorial-layout {
  display: flex;
  gap: 24px;
}

/* 左侧导航样式 */
.tutorial-sidebar {
  width: 260px;
  position: sticky;
  top: 88px;
  height: calc(100vh - 88px);
  overflow-y: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nav-group {
  padding: 16px 0;
}

.nav-group-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.2s;
}

.nav-group-item:hover {
  background: #f1f5f9;
  color: #2563eb;
}

.nav-section-title {
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
  border-bottom: 1px solid #eee;
}

.nav-section-link {
  display: block;
  padding: 8px 16px;
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.nav-section-link:hover {
  background: #f1f5f9;
  color: #2563eb;
}

.nav-section-link.active {
  background: #eff6ff;
  color: #2563eb;
  border-left-color: #2563eb;
}

/* 右侧内容区域样式 */
.tutorial-main {
  flex: 1;
  min-width: 0;
}

.content-wrapper {
  background: white;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 文档内容样式 */
.doc-section {
  margin-bottom: 48px;
  scroll-margin-top: 100px;
}

h1 {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}

h2 {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 20px 0 16px;
}

strong {
  font-weight: 500;
  color: #333;
}

p {
  color: #666;
  line-height: 1.6;
  margin: 8px 0;
  font-size: 14px;
}

.subsection {
  margin-bottom: 32px;
}

.subsection a {
  color: #2563eb;
  text-decoration: none;
  transition: color 0.2s;
}

.subsection a:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

ol.number-list {
  padding-left: 24px;
  margin: 12px 0;
  list-style-type: none;
  counter-reset: item;
}

ol.number-list li {
  margin: 16px 0;
  line-height: 1.6;
  position: relative;
}

ol.number-list li strong {
  display: block;
  margin-bottom: 4px;
}

ol.number-list li p {
  margin-top: 4px;
}



.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer {
  background: #f8fafc;
  padding: 24px 0;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
}

@media (max-width: 400px) {
  .tutorial-layout {
    flex-direction: column;
  }

  .tutorial-sidebar {
    width: 100%;
    position: static;
    height: auto;
  }

  .content-wrapper {
    padding: 20px;
  }
}
</style> 